export default __webpack_public_path__ + "static/media/yellow-cross.e9eac05d.png";